/* eslint-disable react/no-danger */
import React, { useContext, useEffect, useState } from 'react';
import { Portal } from 'react-portal';

import { HeaderActions } from 'global/header/components/HeaderActions';
import { AuthContext } from 'app/containers/AuthContainer';

import PeriodSelect from './PeriodSelect/PeriodSelect';

const PromoHeader = () => {
    const authData = useContext(AuthContext);
    const { isAuthed } = authData;

    const [isCleaned, setIsCleaned] = useState(false);
    const selector = 'global-header-navigation-area';

    useEffect(() => {
        document.getElementById('static-header-navigation--wrapper').remove();
        setIsCleaned(true);
    }, []);

    return (
        <>
            {isCleaned && (
                <Portal node={document && document.getElementById(selector)}>
                    <HeaderActions
                        isAuthed={isAuthed}
                    />
                </Portal>
            )}
            <PeriodSelect />
        </>
    );
};

export default PromoHeader;
